/* eslint-disable react/jsx-props-no-spreading -- passthrough wrapper do InputMoney do core */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { InputMoney } from '@4beefopag/4bee-fopag-core/dist/atoms';

/**
 * Wrapper do InputMoney do core que mantém o draft autoritativo enquanto o campo
 * está focado, evitando que props intermediárias (renders concorrentes da tabela)
 * ressincronizem a máscara para um valor antigo entre teclas.
 */
function StableInputMoney({ value = 0, getValue, onBlur, onFocus, ...rest }) {
  const [focused, setFocused] = useState(false);
  const lastEmittedRef = useRef(value ?? 0);
  const [draftValue, setDraftValue] = useState(value ?? 0);

  useEffect(() => {
    if (!focused) {
      const nextValue = value ?? 0;
      lastEmittedRef.current = nextValue;
      setDraftValue(nextValue);
    }
  }, [value, focused]);

  const handleGetValue = (nextValue) => {
    lastEmittedRef.current = nextValue;
    setDraftValue(nextValue);
    if (getValue) {
      getValue(nextValue);
    }
  };

  const handleFocus = (...args) => {
    setFocused(true);
    if (onFocus) {
      onFocus(...args);
    }
  };

  const handleBlur = (...args) => {
    setFocused(false);
    setDraftValue(lastEmittedRef.current);
    if (onBlur) {
      onBlur(...args);
    }
  };

  const controlledValue = focused ? draftValue : value ?? 0;

  return (
    <InputMoney
      {...rest}
      value={controlledValue}
      getValue={handleGetValue}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
}

StableInputMoney.propTypes = {
  value: PropTypes.number,
  getValue: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default StableInputMoney;
